export { default } from './SelectMenu';


// WEBPACK FOOTER //
// ./src/components/shared/SelectMenu/index.ts